import { render, staticRenderFns } from "./tempAdd.vue?vue&type=template&id=2765d952&scoped=true&"
import script from "./tempAdd.vue?vue&type=script&lang=js&"
export * from "./tempAdd.vue?vue&type=script&lang=js&"
import style0 from "./tempAdd.vue?vue&type=style&index=0&id=2765d952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765d952",
  null
  
)

export default component.exports